var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.actualizando)?_c('apex-chart',{staticClass:"donut-chart",attrs:{"width":"90%","height":"90%","type":"donut","series":_vm.series,"options":_vm.options}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }